<template>
  <div class="chart-panel">
    <vs-divider position="left" class="viewer-divider">Variable</vs-divider>
    <div class="inner-container">
      <ul class="radio-opts label">
        <li v-for="(variable, index) in apiVariables" :key="index">
          <vs-radio
            v-model="activeVariable"
            :color="secondary"
            :vs-value="variable"
            >{{ variable | capitalizeFirst }}</vs-radio
          >
        </li>
      </ul>
    </div>
    <vs-divider class="viewer-divider">Data Serie</vs-divider>
    <line-thresholds-chart
      :z-data-serie="dataSerie"
      :z-variable-info="variableInfo"
      :z-data-source="hindcastResult.data.source"
      :z-data-threshold="chartThresholds"
      :z-subtitle="subtitle"
      :z-title="title"
    />
  </div>
</template>

<script>
import LineChart from "@/components/LineChart";
import { MSPTOOLS_API } from "@/config/apis";

export default {
  components: {
    "line-thresholds-chart": LineChart
  },
  filters: {
    capitalizeFirst: value => {
      if (!value) return "";
      return value[0].toUpperCase() + value.substring(1);
    }
  },
  props: {
    hindcastResult: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      apiVariables: MSPTOOLS_API.historicalData.variables,
      secondary: "#19535F",
      activeVariable: "temperature",
      dataSerie: [],
      variableInfo: { variable: "", units: "" },
      title: "",
      subtitle: ""
    };
  },
  computed: {
    ready() {
      return Object.keys(this.hindcastResult.data).length > 0;
    },
    chartThresholds() {
      return {
        max: this.hindcastResult.params.specie[this.activeVariable][1],
        min: this.hindcastResult.params.specie[this.activeVariable][0]
      };
    },
    roundedCoords() {
      return {
        lon: Number(this.hindcastResult.params.point.lon).toFixed(4),
        lat: Number(this.hindcastResult.params.point.lat).toFixed(4)
      };
    }
  },
  watch: {
    activeVariable() {
      this.setActiveGraphData();
    }
  },
  created() {
    if (this.ready) {
      this.setActiveGraphData();
    }
  },
  methods: {
    setActiveGraphData() {
      const data = this.hindcastResult.data.measures.find(
        measure => measure.var_alias === this.activeVariable
      );
      this.dataSerie = this.prepareData(data.values);
      this.title = `Historical ocean ${data.var_alias} at ${
        this.roundedCoords.lon
      } - ${this.roundedCoords.lat}`;
      this.subtitle = `(thresholds referred to ${
        this.hindcastResult.params.specie.name
      })`;
      this.variableInfo.variable = data.var_alias;
      this.variableInfo.units = data.units;
    },
    prepareData(measures) {
      const dataSerie = [];
      measures.map(measure => {
        const dateTimeInMilliseconds = measure[0] * 1000;
        const roundedValue = parseFloat(Number(measure[1]).toFixed(2));
        dataSerie.push([dateTimeInMilliseconds, roundedValue]);
      });
      return dataSerie;
    }
  }
};
</script>

<style>
.chart-panel {
  flex-grow: 1;
  width: 100%;
}
.inner-container {
  display: flex;
  flex-grow: 1;
  justify-content: flex-start;
  padding-left: 1rem;
}

.radio-opts {
  flex-direction: row;
  display: flex;
  justify-content: space-evenly;
  flex-grow: 1;
}

.radio-opts li {
  padding: 10px;
  margin-left: 10px;
  border-radius: 5px;
  list-style: none;
}
.viewer-divider {
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
